import { getCookie } from "@/utils";

const Configs = {
  get env() {
    return !(
      location.hostname.includes("dash-local.mileiq.com") ||
      location.hostname.includes("localhost") ||
      location.hostname.includes("127.0.0.1")
    ) && location.hostname.includes("mileiq.com")
      ? "prod"
      : "dev";
  },
  get version() {
    return import.meta.env.PACKAGE_VERSION;
  },
  get isMobileDevice() {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent
    );
  },
  get isUserLoggedIn() {
    const cookies = getCookie("user_logged_in");
    return cookies === "true" || cookies === "1";
  },
};

export { Configs };
